import { Colors } from './colors.types'

const colors: Colors = {
  blue100: '#0F1151',
  blue75: '#191D87',
  blue50: '#2327BE',
  blue25: '#7B7DD8',
  blue10: '#BDBEEB',
  blue5: '#F4F4FC',
  violet100: '#361478',
  violet75: '#430CA9',
  violet50: '#6D29F0',
  violet25: '#B694F8',
  violet10: '#D3BEFA',
  violet5: '#F8F4FE',
  red100: '#6E1A1A',
  red75: '#AF171D',
  red50: '#DD3435',
  red25: '#EB8586',
  red10: '#F5C2C2',
  red5: '#FCEAEA',
  yellow100: '#7F5A10',
  yellow75: '#E09500',
  yellow50: '#FFB521',
  yellow25: '#FFD37A',
  yellow10: '#FFE9BC',
  yellow5: '#FFF7E8',
  black100: '#141420',
  black75: '#333346',
  black60: '#5C5C6B',
  black50: '#858590',
  black25: '#BDBDC4',
  black10: '#E1E1E3',
  black5: '#F5F5F6',
  white: '#FFFFFF',
  white75: '#FFFFFF75',
  green: '#63A851',
  brown: '#886B40',
  overlay95: 'rgba(20, 20, 32, 0.95)',
  overlay75: 'rgba(20, 20, 32, 0.75)',
  overlay50: 'rgba(20, 20, 32, 0.50)',
  overlay25: 'rgba(20, 20, 32, 0.25)',
  overlay15: 'rgba(20, 20, 32, 0.15)',
}

export default colors
